/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var RoRoSeaShippingMethod;
(function (RoRoSeaShippingMethod) {
    let vessel_type;
    (function (vessel_type) {
        vessel_type["SEA_RORO"] = "sea_roro";
    })(vessel_type = RoRoSeaShippingMethod.vessel_type || (RoRoSeaShippingMethod.vessel_type = {}));
    let fuel;
    (function (fuel) {
        fuel["HFO"] = "HFO";
        fuel["MGO"] = "MGO";
    })(fuel = RoRoSeaShippingMethod.fuel || (RoRoSeaShippingMethod.fuel = {}));
    let load;
    (function (load) {
        load["FREIGHT_ONLY"] = "freight_only";
        load["TRUCK_AND_TRAILER"] = "truck_and_trailer";
        load["TRAILER_ONLY"] = "trailer_only";
    })(load = RoRoSeaShippingMethod.load || (RoRoSeaShippingMethod.load = {}));
})(RoRoSeaShippingMethod || (RoRoSeaShippingMethod = {}));
//# sourceMappingURL=RoRoSeaShippingMethod.js.map